import { render, staticRenderFns } from "./bottomright.vue?vue&type=template&id=71742c3e&scoped=true&"
import script from "./bottomright.vue?vue&type=script&lang=js&"
export * from "./bottomright.vue?vue&type=script&lang=js&"
import style0 from "./bottomright.vue?vue&type=style&index=0&id=71742c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71742c3e",
  null
  
)

export default component.exports